import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(4, 0),
    width: 'fit-content'
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  cttExpressPointButtonContained: {
    border: '1px solid #526C0C',
    backgroundColor: '#D2E490',
    color: '#526C0C',
    '&:hover': {
      border: '1px solid #526C0C',
      backgroundColor: '#D2E490',
      color: '#526C0C',
      boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.2)',
    },
  },
  cttExpressPointButtonOutlined: {
    border: '1px solid #E1EDB5',
    color: '#526C0C',
    backgroundColor: 'white',
    '&:hover': {
      border: '1px solid #526C0C',
      color: '#526C0C',
      backgroundColor: 'white',
      boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.2)',
    },
  },
}))

export default useStyles
